module.exports = __webpack_public_path__ + "static/media/me.b3356a62.JPG";